import { ARCHIVE_CUTOFF_CLAIM_NUMBER } from "../../archiveApp.js";

// THE ARCHIVE BRANCH'S ONE LOUD DIVERGENCE (Robert 2026-08-21). This app is
// the frozen half of the two-site plan — every job below the boundary,
// records as at the 1.0 retirement — and the banner is how nobody ever
// wonders which system they are in. Editing is deliberately NOT blocked
// (Robert: old jobs sometimes need a correction); the banner carries the
// context that makes an edit here a considered act instead of a mistake.
//
// Hardcoded in this branch on purpose — no mainline mode, no setting, no
// way to turn it off. An archive that can stop announcing itself isn't one.
function ArchiveBanner() {
  return (
    <div
      className="text-center py-1 fw-semibold text-uppercase"
      style={{ background: "#6c757d", color: "#fff", letterSpacing: "0.08em", fontSize: "0.8rem" }}
    >
      Archive — jobs before #{ARCHIVE_CUTOFF_CLAIM_NUMBER} · current work lives in ClaimsDesk Live
    </div>
  );
}

export default ArchiveBanner;
